var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-rounded focus:outline-none",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',[_c('vc-icon',{attrs:{"icon":_vm.icon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }